import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";
import { toast } from "react-toastify";
import { isLink } from "../../Utils/LinkUtils";

const SaveSearchModal = ({ show, onHide, onSave, saveSearchLoading }) => {
  const [searchName, setSearchName] = useState("");
  const [comment, setComment] = useState("");
  const [link, setLink] = useState("");
  const [touched, setTouched] = useState(false);

  const isNameValid = searchName.trim().length >= 1;
  const showError = touched && !isNameValid;

  const handleSave = () => {
    setTouched(true);

    if (isNameValid) {
      onSave({ searchName, comment, link });
    } else {
      toast.error("Search name is required");
    }
  };

  const handleOpenLink = () => {
    const isValidLink = isLink(link.trim());
    if (isValidLink) {
      window.open(link, "_blank");
    } else {
      toast.error("Please enter the valid link");
    }
  };

  const handleClose = () => {
    setSearchName("");
    setComment("");
    setLink("");
    setTouched(false);
    onHide();
  };

  return (
    <Modal isOpen={show} toggle={onHide} size="lg" onClosed={handleClose}>
      <ModalHeader toggle={onHide}>
        <span style={{ fontSize: "18px" }}>Save Search</span>
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="searchName">
              Name of Search <span className="text-danger">*</span>
            </Label>
            <Input
              type="text"
              id="searchName"
              value={searchName}
              invalid={showError}
              onChange={(e) => {
                setSearchName(e.target.value);
                setTouched(true);
              }}
              onBlur={() => setTouched(true)}
            />
            <FormFeedback>Search name is required</FormFeedback>
          </FormGroup>

          <FormGroup className="mt-3">
            <Label for="comment">Enter Comment for this Search</Label>
            <Input
              type="textarea"
              id="comment"
              rows="3"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </FormGroup>

          <FormGroup className="mt-3">
            <Label for="link">Enter Links for this Comment</Label>
            <Input
              type="text"
              id="link"
              value={link}
              onChange={(e) => setLink(e.target.value)}
            />
          </FormGroup>

          <Button
            color="secondary"
            outline
            onClick={handleOpenLink}
            className="mt-2"
          >
            Navigate to above Link
          </Button>
        </Form>
      </ModalBody>

      <ModalFooter>
        <Button
          color="primary"
          onClick={handleSave}
          className="create-button"
          disabled={showError || saveSearchLoading}
        >
          {saveSearchLoading ? "Saving..." : "Save"}
        </Button>
        <Button color="secondary" outline onClick={handleClose}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SaveSearchModal;
